/** A6.1's words. Source values remain source evidence. */
export const historyCopy = {
  history: "Course History",
  forbidden: "Course history is not available to this account.",
  goBack: "Go back",
  sections: "Closed sections",
  searchClasses: "Search classes",
  moreFilters: "More filters",
  readClassRecord: "Read class record",
  studentRecord: "Student record",
  runs: "Import runs",
  provenance: "Provenance and coverage",
  roster: "Historical roster",
  coursework: "Coursework evidence",
  materials: "Materials",
  outcomes: "Certified outcomes",
  continuation: "Continuation",
  receipts: "Receipts",
  notices: "Notices and omissions",
  missingName: "Name not recorded",
  noCoursework: "No coursework evidence was present in this source.",
  noSubmissions: "No submission evidence was present for this learner.",
  sourceMissing: "Not present in source",
  conflicts: "Repeated receipts disagree, so no value was chosen.",
  failed: "This record could not be read. Try again.",
  stale: "Couldn't refresh. A later change isn't shown.",
} as const;

/** Canonical words shared by the two registrar history journeys. */
export const historyWords = {
  noEvidenceRecorded: "No evidence recorded",
  readTheChangedSourceBeforeApplying: "Read the changed source before applying.",
  recordedEvidence: "Recorded evidence",
  readEvidence: "Read evidence",
  readWhereTheClosedRecordCameFrom: "Read where the closed record came from",
  imported: "Imported",
  nativeIMAMRecord: "Native IMAM record",
  importedAcademicRecordMissingSourceEvidenceDoesNotMeanZero: "Imported academic record. Missing source evidence does not mean zero.",
  nativeIMAMAcademicRecord: "Native IMAM academic record.",
  explicitlyOmitted: ": explicitly omitted. ",
  noProviderCourseEvidenceWasRecorded: "No provider course evidence was recorded.",
  importRun: "Import run",
  submissionEvidence: "Submission evidence",
  typeNotRecorded: "Type not recorded",
  openMaterialAtItsSourceNewTab: "Open material at its source (new tab)",
  theContinuationWasRemoved: "The continuation was removed.",
  theContinuationWasRecorded: "The continuation was recorded.",
  itsAuditHistoryRemainsReadable: "Its audit history remains readable.",
  continuationNotConfirmed: "Continuation not confirmed",
  theContinuationMayHaveChangedCheckTheOriginalReceiptBeforeSendingAgain: "The continuation may have changed. Check the original receipt before sending again.",
  check: "Check",
  readsTheOriginalReceiptWithoutChangingALink: "Reads the original receipt without changing a link.",
  noChangeRecorded: "No change recorded",
  noReceiptWasRecordedForThisCommandReviewTheKeptChoiceBeforeSaving: "No receipt was recorded for this command. Review the kept choice before saving.",
  chooseTheExactSectionThisCourseContinuesInto: "Choose the exact section this course continues into.",
  recordOrRemoveOneExplicitlyChosenContinuation: "Record or remove one explicitly chosen continuation",
  continuation: "Continuation",
  noContinuationRecorded: "No continuation recorded",
  changeRecorded: "Change recorded",
  continuationRecorded: "Continuation recorded",
  reviewContinuation: "Review continuation",
  continuationChoice: "Continuation choice",
  choiceNotRecorded: "Choice not recorded",
  readTheRecordedLink: "Read the recorded link",
  theContinuationChangedAfterThisDraftBegan: "The continuation changed after this draft began.",
  currentContinuation: "Current continuation",
  keepMyContinuationChoice: "Keep my continuation choice",
  useTheRecordedContinuation: "Use the recorded continuation",
  removeThisLinkBeforeRecordingAnother: ". Remove this link before recording another.",
  changeToRecord: "Change to record",
  chooseAChange: "Choose a change",
  removeTheContinuation: "Remove the continuation",
  recordAContinuation: "Record a continuation",
  findASection: "Find a section",
  readingSections: "Reading sections",
  sectionsCouldNotBeRead: "Sections could not be read. ",
  tryAgain: "Try again",
  sectionThisCourseContinuesInto: "Section this course continues into",
  chooseTheExactSection: "Choose the exact section",
  previousRemovalsRemainInTheAuditHistory: "previous removals remain in the audit history.",
  removeContinuation: "Remove continuation",
  recordContinuation: "Record continuation",
  whenYouRecordThisChoice: "When you record this choice",
  removeThisContinuationAndRetainTheAuditRecord: "Remove this continuation and retain the audit record.",
  linkThisHistoricalCourseToExactlyTheSectionYouChoseWithoutChangingEither: "Link this historical course to exactly the section you chose, without changing either academic record.",
  noChoiceRecorded: "No choice recorded",
  readTheContinuationAndChooseAChangeFirst: "Read the continuation and choose a change first.",
  continuationNotRecorded: "Continuation not recorded",
  yes: "Yes",
  no: "No",
  noneRecorded: "None recorded",
  sourceEvidenceSeparateFromIMAMSCertifiedOutcomes: "Source evidence, separate from IMAM's certified outcomes.",
  conflictingSourceValues: "Conflicting source values",
  recordedIn: "Recorded in ",
  receipts: "receipts.",
  readRun: "Read run ",
  auditReferences: "Audit references",
  classroomSourceInstructorEvidence: "Classroom source instructor evidence",
  classroomSourceInstructorEvidenceEachInstructorRecordIsYourChoice: "Classroom source instructor evidence. Each instructor record is your choice.",
  noSourceInstructorWasReturnedByClassroom: "No source instructor was returned by Classroom.",
  theClassroomConnectionExpiredConnectAgainToReadClassroom: "The Classroom connection expired. Connect again to read Classroom.",
  googleRefusedThisConnectionConnectAgainToReadClassroom: "Google refused this connection. Connect again to read Classroom.",
  classroomCouldNotBeRead: "Classroom could not be read.",
  unresolved: "Unresolved",
  readAnArchivedClassroomCourseFirst: "Read an archived Classroom course first.",
  nameTheClosedTermCourseCodeAndCredits: "Name the closed term, course code and credits.",
  chooseEveryInstructorRecordExplicitly: "Choose every instructor record explicitly.",
  iMAMCourseRecord: "IMAM course record",
  notApplied: "Not applied",
  noSourceRead: "No source read",
  classroomEvidence: "Classroom evidence: ",
  learners: "learners, ",
  courseworkItemsAssignmentGradesRemainSourceEvidence: "coursework items. Assignment grades remain source evidence.",
  closedTermName: "Closed term name",
  institutionalCourseCode: "Institutional course code",
  credits: "Credits",
  readAnArchivedCourseFromClassroomItSuppliesEvidenceNeverInstitutionalIdentityCredits: "Read an archived course from Classroom. It supplies evidence, never institutional identity, credits or certified outcomes.",
  instructors: "Instructors",
  explicitInstructorChoices: "Explicit instructor choices",
  isSourceEvidence: "is source evidence.",
  instructorRecordFor: "Instructor record for ",
  chooseARecord: "Choose a record",
  createAccountlessHistoricalRecord: "Create accountless historical record",
  teachingAttributionFor: "Teaching attribution for ",
  chooseAttribution: "Choose attribution",
  primaryInstructor: "Primary instructor",
  coInstructor: "Co-instructor",
  batches: "Batches",
  atMost100SourceRowsPerBatchIncludingAtMost: "At most 100 source rows per batch, including at most ",
  learnersDryRunAndApplyEachBatchSeparately: "learners. Dry run and apply each batch separately.",
  batchToReview: "Batch to review",
  batch: "Batch ",
  of: "of ",
  learners2: "learners",
  classroomImportIsnTSetUpForMufid: "Classroom import isn't set up for Mufid.",
  notReadFromClassroomYet: "Not read from Classroom yet.",
  readArchivedClassroomSourceEvidence: "Read archived Classroom source evidence",
  archivedInClassroom: "Archived in Classroom",
  sourceEvidence: "Source evidence",
  connectClassroomOpensGoogleConsent: "Connect Classroom (opens Google consent)",
  archivedCourse: "Archived course",
  readThisCourse: "Read this course",
  read: "Read ",
  readingClassroomEvidence: "Reading Classroom evidence",
  theCourseCouldNotBeRead: "The course could not be read.",
  clearThisPageSClassroomConnectionAndUnappliedEvidence: "Clear this page's Classroom connection and unapplied evidence",
  disconnectClassroom: "Disconnect Classroom",
  clearThisPageSConnectionAndUnappliedReviewOnly: "Clear this page's connection and unapplied review only",
  disconnected: "Disconnected",
  connectedInThisPage: "Connected in this page",
  reviewDisconnect: "Review disconnect",
  whenYouDisconnectThisPage: "When you disconnect this page",
  clearThisPageSClassroomConnectionEvidenceAndUnappliedCourseDraftChangeNothing: "Clear this page's Classroom connection, evidence and unapplied course draft. Change nothing in IMAM or Classroom.",
  thisPageSClassroomConnectionAndUnappliedEvidenceWereCleared: "This page's Classroom connection and unapplied evidence were cleared.",
  iMAMRecordsAndClassroomAreUnchanged: "IMAM records and Classroom are unchanged.",
  registrarRoster: "Registrar roster",
  thisFileCouldNotBeRead: "This file could not be read.",
  rosterFile: "Roster file",
  chooseTheFileReviewEachLearnerThenReadADryRunARoster: "Choose the file, review each learner, then read a dry run. A roster creates no invitation.",
  sourceRows: "source rows.",
  bringInAClosedCourse: "Bring in a closed course",
  sourceRowsThisImportGrantsNoPortalAccessAndCertifiesNoInferredOutcome: "source rows. This import grants no portal access and certifies no inferred outcome.",
  readTheSourceEvidence: "Read the source evidence",
  readAnArchivedClassroomCourseAndCompleteItsInstitutionalRecordAbove: "Read an archived Classroom course and complete its institutional record above.",
  thisSourceHasNoRowList: "This source has no row list.",
  thisSourceCouldNotBeRead: "This source could not be read.",
  readASourceWithAtLeastOneRow: "Read a source with at least one row.",
  aBatchHoldsAtMost100RowsSplitThisSourceBeforeApplying: "A batch holds at most 100 rows. Split this source before applying.",
  retryRefusedRows: "Retry refused rows",
  onlyTheRefusedRowsUnderTheOriginalSourceAndChoicesAreRetried: "Only the refused rows under the original source and choices are retried.",
  rosterEnrollmentNoticeConsequence: "Each new enrollment into a published section makes one enrollment notice eligible. Email may be sent after Apply.",
  rosterEnrollmentNoticeResult: "New enrollments into published sections are eligible for enrollment notices. This receipt does not confirm email delivery.",
  invitationsAreASeparateChoiceInTheRunRecord: "Invitations are a separate choice in the run record.",
  noPortalAccessWasGrantedByThisImport: "No portal access was granted by this import.",
  applyNotConfirmed: "Apply not confirmed",
  theSourceMayHaveBeenAppliedCheckItsReceiptBeforeSendingAgain: "The source may have been applied. Check its receipt before sending again.",
  readsTheOriginalCommandSReceiptAndNeverAppliesItAgain: "Reads the original command's receipt and never applies it again.",
  noApplyRecorded: "No apply recorded",
  thisCommandHasNoReceiptYourSourceAndChoicesAreKeptReviewThem: "This command has no receipt. Your source and choices are kept; review them before applying.",
  aDifferentCommandOwnsThisReceipt: "A different command owns this receipt.",
  applyRefused: "Apply refused",
  dryRunCouldNotBeRead: "Dry run could not be read.",
  reviewThisExactSourceAndApplyItsExplicitlyChosenRecords: "Review this exact source and apply its explicitly chosen records",
  readASourceFirst: "Read a source first",
  applied: "Applied",
  reviewSource: "Review source",
  review: "Review",
  sourceAndIMAMRecord: "Source and IMAM record",
  readNotApplied: "Read, not applied",
  learners4: "Learners",
  aNamedChoiceIsNeeded: "A named choice is needed",
  choicesRecordedInTheDraft: "Choices recorded in the draft",
  readTheSourceToReviewItsLearners: "Read the source to review its learners.",
  dryRun: "Dry run",
  reading: "Reading",
  exactlyThisSourceReviewed: "Exactly this source reviewed",
  previewNeeded: "Preview needed",
  readDryRun: "Read dry run",
  theDryRunRecordsARunAndReceiptsItWritesNoAcademicRecord: "The dry run records a run and receipts. It writes no academic record. Any source or choice edit requires another dry run.",
  dryRunOfThisSource: "Dry run of this source",
  earlierSourcePreviewAgain: "Earlier source, preview again",
  wouldCreate: "would create, ",
  matched: "matched, ",
  leftOut: "left out, ",
  refused: "refused.",
  runRecord: "Run record",
  inviteStudents: "Invite students",
  applySource: "Apply source",
  whenYouApplyThisSource: "When you apply this source",
  noSource: "No source",
  readASourceFirst2: "Read a source first.",
  readyForAnInvitationChoice: "Ready for an invitation choice",
  alreadySignsIn: "Already signs in",
  invitationAlreadyOpen: "Invitation already open",
  studentRecordInactive: "Student record inactive",
  noRecordedDeliveryContact: "No recorded delivery contact",
  notRecordedByARegistrarRoster: "Not recorded by a registrar roster",
  readThisTenantSManagedWorkspaceBeforeComposingInvitations: "Read this tenant's managed Workspace before composing invitations.",
  selectTheStudentsToInvite: "Select the students to invite.",
  inviteAtMost100StudentsInOneCommand: "Invite at most 100 students in one command.",
  readTheRosterBeforeInviting: "Read the roster before inviting.",
  theRosterAndAcademicRecordAreUnchanged: "The roster and academic record are unchanged.",
  retryFailedInvitations: "Retry failed invitations",
  sendsOnlyTheFailedInvitationsUnderTheOriginalKeyAndUnchangedInvitationDetails: "Sends only the failed invitations under the original key and unchanged invitation details.",
  checkInvitations: "Check invitations",
  readsOnlyTheInvitationIdsRecordedOnThisOriginalCommand: "Reads only the invitation ids recorded on this original command.",
  invitationsNotConfirmed: "Invitations not confirmed",
  anInvitationMayHaveBeenSentCheckThisOriginalCommandBeforeSendingAgain: "An invitation may have been sent. Check this original command before sending again.",
  readsTheOriginalCommandNeverSendsEmail: "Reads the original command; never sends email.",
  noInvitationCommandRecorded: "No invitation command recorded",
  noReceiptWasRecordedYourSelectedStudentsAndAddressChoicesAreKeptFor: "No receipt was recorded. Your selected students and address choices are kept for review.",
  invitationsRefused: "Invitations refused",
  chooseTheRecordedStudentsToInvite: "Choose the recorded students to invite",
  rosterStudents: "Roster students",
  invitationsAreASeparateChoice: "Invitations are a separate choice",
  noDeliveryContact: "No delivery contact",
  select: "Select",
  reviewExactlyWhoReceivesAnInvitation: "Review exactly who receives an invitation",
  inviteSelectedStudents: "Invite selected students",
  invitationsRecorded: "Invitations recorded",
  reviewRecipients: "Review recipients",
  reviewInvitations: "Review invitations",
  namesAndDeliveryAddresses: "Names and delivery addresses",
  reviewBeforeSending: "Review before sending",
  aSelectedStudentIsNoLongerInThisRosterRead: "A selected student is no longer in this roster read.",
  recordedContact: "Recorded contact: ",
  none: "None",
  thisAddressIsDeliveryEvidenceNeverIdentity: ". This address is delivery evidence, never identity.",
  useProposedNamesAndAccountFor: "Use proposed names and account for ",
  givenName: "Given name",
  familyName: "Family name",
  managedAccount: "Managed account",
  deliveryEmail: "Delivery email",
  for: "for ",
  managedAccount2: "Managed account: ",
  notChosen: "Not chosen",
  whenYouInviteTheseStudents: "When you invite these students",
  theCorrectionWasAppendedToTheAcademicRecord: "The correction was appended to the academic record.",
  theOriginalAndEveryCorrectionRemainReadableInTheChain: "The original and every correction remain readable in the chain.",
  correctionNotConfirmed: "Correction not confirmed",
  theCorrectionMayHaveBeenRecordedCheckTheOriginalReceiptBeforeSendingAgain: "The correction may have been recorded. Check the original receipt before sending again.",
  readsTheOriginalCommandWithoutAppendingAnotherCorrection: "Reads the original command, without appending another correction.",
  noCorrectionRecorded: "No correction recorded",
  thisCommandHasNoReceiptReviewTheKeptFieldsBeforeRecordingACorrection: "This command has no receipt. Review the kept fields before recording a correction.",
  readTheCorrectionChainBeforeChangingItsStandingReceipt: "Read the correction chain before changing its standing receipt.",
  nameAtLeastOneCorrectedFieldAsAJSONObject: "Name at least one corrected field as a JSON object.",
  readHistoricalSection: "Read historical section",
  readLearnerRecord: "Read learner record",
  sourceEvidenceAsRecorded: "Source evidence as recorded",
  readCorrectionHistory: "Read correction history",
  readingCorrectionHistory: "Reading correction history",
  theChainCouldNotBeReadItsStandingValueIsUnknown: "The chain could not be read. Its standing value is unknown.",
  sourceApplied: "Source applied",
  standingReceipt: " · Standing receipt",
  superseded: " · Superseded",
  correction2: "Correction",
  draftCorrection: "Draft correction",
  noCorrectionEntered: "No correction entered",
  anotherCorrectionChangedTheStandingReceipt: "Another correction changed the standing receipt.",
  standingCorrection: "Standing correction",
  keepMyCorrectionOnTheStandingReceipt: "Keep my correction on the standing receipt",
  useTheStandingReceipt: "Use the standing receipt",
  reasonForCorrection: "Reason for correction",
  evidenceReference: "Evidence reference",
  downstreamImpact: "Downstream impact",
  correctedFieldsJSON: "Corrected fields (JSON)",
  readTheChainBeforeEnteringACorrection: "Read the chain before entering a correction.",
  recordCorrection: "Record correction",
  whenYouCorrectThisReceipt: "When you correct this receipt",
  appendThisCorrectionToTheStandingReceiptPreservingEveryEarlierValueAndThe: "Append this correction to the standing receipt, preserving every earlier value and the evidence you name.",
  correctionNotRecorded: "Correction not recorded",
  readTheStandingReceiptAndCompleteAllFourFields: "Read the standing receipt and complete all four fields.",
  correctionRefused: "Correction refused",
  readTheSourceAndOutcomeOfThisRun: "Read the source and outcome of this run",
  appliedSource: "Applied source",
  theRequestedReceiptIsNotInThisRunNoOtherReceiptWasSubstituted: "The requested receipt is not in this run. No other receipt was substituted.",
  sourceDigest: "Source digest",
  runBy: "Run by",
  outcome: "Outcome",
  theRunHasNotFinished: "The run has not finished.",
  wouldCreate2: "Would create",
  created: "Created",
  matched2: "Matched",
  leftOut2: "Left out",
  refused2: "Refused",
  readWhatThisRunObservedAndLeftOut: "Read what this run observed and left out",
  recordedWithTheRun: "Recorded with the run",
  readEachRowSReceiptAndItsSourceEvidence: "Read each row's receipt and its source evidence",
  receiptsKept: "Receipts kept",
  readReceipt: "Read receipt",
  thisReceiptIsAProjectionThereIsNoWrittenValueToCorrect: "This receipt is a projection. There is no written value to correct.",
  eachLearnerHasARecordedSourceIDTheDryRunVerifiesTheRecord: "Each learner has a recorded source ID. The dry run verifies the record it names.",
  chooseEachLearnerSRecordExplicitlyANameOrDeliveryAddressNeverChooses: "Choose each learner's record explicitly. A name or delivery address never chooses a record.",
  findAStudentRecord: "Find a student record",
  readingStudentRecords: "Reading student records",
  studentRecordsCouldNotBeRead: "Student records could not be read. ",
  unnamedSourceLearner: "Unnamed source learner",
  noContactRecorded: "No contact recorded",
  decisionFor: "Decision for ",
  chooseAStudentRecordBelowCreateOrLeaveOut: "Choose a student record below, create, or leave out",
  linkTo: "Link to ",
  createAHistoricalRecord: "Create a historical record",
  createAStudentRecord: "Create a student record",
  leaveOut: "Leave out",
  link: "Link ",
  toThePersonIChoose: "to the person I choose",
  unnamedStudent: "Unnamed student",
  noSID: "No SID",
  chooseAnExistingStudentRecord: "Choose an existing student record",
  theStudentRecordYouChose: "The student record you chose",
  faculty: "Faculty",
  term: "Term",
  program: "Program",
  filterChoicesCouldNotBeRefreshed: "Filter choices could not be refreshed.",
  source2: "Source",
  allSources: "All sources",
  native: "Native",
  anyContinuation: "Any continuation",
  findAClosedSectionAndVisitItsHistoricalRecord: "Find a closed section and visit its historical record",
  closedTermHistory: "Closed-term history",
  noHistoricalSectionsMatch: "No historical sections match",
  closedSections: "Closed sections",
  continuations: "Continuations",
  matching: "Matching",
  readHistory: "Read history",
  searchCourseHistory: "Search course history",
  historyPages: "History pages",
  previous: "Previous",
  page: "Page ",
  next: "Next",
  findAnImportRunAndReadItsReceipts: "Find an import run and read its receipts",
  importRuns: "Import runs",
  runsRecorded: "Runs recorded",
  noImportRunsYet: "No import runs yet",
  runs: "Runs",
  dryRuns: "Dry runs",
  refusedRows: "Refused rows",
  readRun2: "Read run",
} as const;

export const historyText = {
  noHistoricalEvidence: (facet: string) => `No ${facet}${facet.endsWith("evidence") ? "" : " evidence"} was recorded in this section. Missing source evidence does not mean zero.`,
  records: (v0: unknown) => ["", String(v0), " records"].join(""),
  accountlessHistoricalRecord: (v0: unknown) => ["", String(v0), " - accountless historical record"].join(""),
  coInstructors: (v0: unknown, v1: unknown) => ["", String(v0), " + ", String(v1), " co-instructors"].join(""),
  batchOf: (v0: unknown, v1: unknown) => ["Batch ", String(v0), " of ", String(v1), ""].join(""),
  archivedCourses: (v0: unknown) => ["", String(v0), " archived courses"].join(""),
  chooseARecordCreateOrLeaveOutForLearners: (v0: unknown) => ["Choose a record, create, or leave out for ", String(v0), " learners."].join(""),
  sourceRowsRecordedWithTheirReceipts: (v0: unknown) => ["", String(v0), " source rows recorded with their receipts."].join(""),
  resolveSourceRowsIntoThisInstitutionSAcademicRecordLeaveOutOnlyThe: (v0: unknown) => ["Resolve ", String(v0), " source rows into this institution's academic record; leave out only the learners you chose."].join(""),
  cannotBeInvitedFromThisRosterNow: (v0: unknown) => ["", String(v0), " cannot be invited from this roster now."].join(""),
  reviewBothNamesManagedAccountAndDeliveryAddressFor: (v0: unknown) => ["Review both names, managed account and delivery address for ", String(v0), "."].join(""),
  recordedStudents: (v0: unknown) => ["", String(v0), " recorded students"].join(""),
  invite: (v0: unknown) => ["Invite ", String(v0), ""].join(""),
  selected: (v0: unknown) => ["", String(v0), " selected"].join(""),
  inviteStudents2: (v0: unknown) => ["Invite ", String(v0), " students"].join(""),
  createOrReuseAndEmailSetupInstructionsToFor: (v0: unknown, v1: unknown, v2: unknown, v3: unknown) => ["Create or reuse ", String(v0), "@", String(v1), " and email setup instructions to ", String(v2), " for ", String(v3), "."].join(""),
  forThisCorrection: (v0: unknown) => ["", String(v0), " for this correction."].join(""),
  noticesOmissions: (v0: unknown, v1: unknown) => ["", String(v0), " notices · ", String(v1), " omissions"].join(""),
  rowReceipts: (v0: unknown) => ["", String(v0), " row receipts"].join(""),
  all: (v0: unknown) => ["All ", String(v0), ""].join(""),
  selected2: (v0: unknown, v1: unknown) => ["Selected ", String(v0), "", String(v1), ""].join(""),
  coverage: (v0: unknown, v1: unknown) => ["", String(v0), "", String(v1), " coverage"].join(""),
  anyCoverage: (v0: unknown) => ["", String(v0), ": any coverage"].join(""),
  present: (v0: unknown) => ["", String(v0), ": present"].join(""),
  explicitlyOmitted2: (v0: unknown) => ["", String(v0), ": explicitly omitted"].join(""),
  neverSourced: (v0: unknown) => ["", String(v0), ": never sourced"].join(""),
  historicalSectionsMatch: (v0: unknown) => ["", String(v0), " historical sections match"].join(""),
  students: (v0: unknown, v1: unknown, v2: unknown, v3: unknown) => ["", String(v0), " · ", String(v1), " students · ", String(v2), " · ", String(v3), ""].join(""),
  search: (v0: unknown) => ["Search: ", String(v0), ""].join(""),
  recordedRuns: (v0: unknown) => ["", String(v0), " recorded runs"].join(""),
  refusedRows2: (v0: unknown, v1: unknown, v2: unknown) => ["", String(v0), " · ", String(v1), " · ", String(v2), " refused rows"].join(""),
} as const;

// Bounded source enums are display words; source ids and timestamps stay verbatim.
export const historySourceWords: ReadonlyMap<string, string> = new Map(Object.entries({
  google_classroom: "Google Classroom", ARCHIVED: "Archived", ACTIVE: "Active", PROVISIONED: "Provisioned", DECLINED: "Declined",
  PUBLISHED: "Published", DRAFT: "Draft", DELETED: "Deleted", ASSIGNMENT: "Assignment", SHORT_ANSWER_QUESTION: "Short-answer question", MULTIPLE_CHOICE_QUESTION: "Multiple-choice question",
  TOTAL_POINTS: "Total points", WEIGHTED_CATEGORIES: "Weighted categories", NONE: "No overall grade calculation", HIDE_OVERALL_GRADE: "Overall grade hidden", SHOW_OVERALL_GRADE: "Overall grade shown",
  NEW: "Not handed in", CREATED: "Created", TURNED_IN: "Handed in", RETURNED: "Returned", RECLAIMED_BY_STUDENT: "Reclaimed by the learner",
}));
